import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseService } from './base/base.service';

import { ObjectResponse } from '../interfaces';
import { AppConfig } from './app-config';
import { TenantEula } from '../models/tenantEula';

@Injectable()
export class EulaService extends BaseService<TenantEula> {
  constructor(http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  // TODO: override, remove when all responses refactored and base updated
  public fetch(queryString?: string): Observable<ObjectResponse<TenantEula>> {
    const apiUrl = this.applyQueryString(queryString);

    return this.http.get<ObjectResponse<TenantEula>>(apiUrl);
  }

  protected getResourceUrl(): string {
    return `${this.baseUrl}user/license/`;
  }
}
